import React from "react";
import "./App.css";
import { Navigate, Route, Routes } from "react-router-dom";
import Dashboard from "./Admin/Main/Pages/Dashboard/Dashboard";
import User from "./Admin/Main/Pages/User/User";
import SubCategory from "./Admin/Main/Pages/Sub-Category/SubCategory";
import Product from "./Admin/Main/Pages/Product/Product";
import Order from "./Admin/Main/Pages/Order/Order";
import Content from "./Admin/Main/Pages/Content Mngt/Content";
import Profile from "./Admin/Main/Pages/Setting/Profile";
import ChangePassword from "./Admin/Main/Pages/Setting/ChangePassword";
import Login from "./Admin/Login/Login";
import Main from "./Admin/Main/Main";
import { ToastContainer } from "react-toastify";
import ForgetPassword from "./Admin/Forget Password/ForgetPassword";
import CompanyDetails from "./Admin/Main/Pages/CompanyDetails/companydetails";
import PriceList from "./Admin/Main/Pages/PriceList/PriceList";
import CanvasSplits from "./Admin/Main/Pages/CanvasSplits_list/CanvasSplits_list";
import Salestax from "./Admin/Main/Pages/Sales_tax/Sales_tax";
import MailList from "./Admin/Main/Pages/Mail_list/Mail_list";
import Coupon from "./Admin/Main/Pages/Coupon/Coupon";
import Banner from "./Admin/Main/Pages/Banner/Banner";
import GiftVouchers from "./Admin/Main/Pages/GiftVouchers/Giftvouchers";
import PersonalShopperList from "./Admin/Main/Pages/personal_shopper_list/PersonalShopperList";
import Topquestion from "./Admin/Main/Pages/Top_questions/Topquestions";
import DigitalServices from "./Admin/Main/Pages/digital_services/DigitalServices";
import FooterName from "./Admin/Main/Pages/footer_name_list/FooterNameList";
import Paymentcredentails from "./Admin/Main/Pages/payment_credentails/Paymentcredentails";
import ImageListing from "./Admin/Main/Pages/Canvas frames/Image_listing";
import EdgeListing from "./Admin/Main/Pages/Canvas frames/Edge_listing";
import FramesListing from "./Admin/Main/Pages/Canvas frames/Frames";
import GalleryWallListing from "./Admin/Main/Pages/Canvas frames/Gallery_Wall_Config";
import ShippingInformation from "./Admin/Main/Pages/Shipping/Shipping_Information";
import Shippingcharges from "./Admin/Main/Pages/Shipping/Shipping_charges";
import Shippingpages from "./Admin/Main/Pages/Shipping/Shipping_page";
import ManageSEO from "./Admin/Main/Pages/ManageSEO/Manage_SEO";
import CartMail from "./Admin/Main/Pages/Customer_Management/Cart_mail";
import StateList from "./Admin/Main/Pages/State_List/StateList";
import HeaderImageListing from "./Admin/Main/Pages/Header_Image/Header_Image_Listing";
import Transaction from "./Admin/Main/Pages/Transaction/Transaction";
import ResetPassword from "./Admin/Reset Password/ResetPassword";
import ViewOrder from "./Admin/Main/Pages/Order/View_order";
import DeliveryPartner from "./Admin/Main/Pages/Delivery_Partner/Delivery_partner";
import CanvasPrint from "./Admin/Main/Pages/Category/CanvasPrint";
import Print from "./Admin/Main/Pages/Category/Print";
import Faq from "./Admin/Main/Pages/FAQ/Faq";
import ConnectedCustomers from "./Admin/Main/Pages/Connected Customers/ConnectedCustomers";
import EmailTemplate from "./Admin/Main/Pages/Email Template/EmailTemplate";
import PrivacyPolicy from "./Admin/Main/Pages/Content Mngt/PrivacyPolicy";
import BioVideo from "./Admin/Main/Pages/Content Mngt/BioVideo";

function App() {
  return (
    <div className="container-scroller">
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgetPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />

        <Route path="/panel" element={<Main />}>
          <Route path="" element={<Navigate to="dashboard" />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="user" element={<User />} />
          <Route path="Print/:type" element={<Print />} />
          <Route path="CanvasPrint" element={<CanvasPrint />} />
          <Route path="canvasSplits_list" element={<CanvasSplits />} />
          <Route path="canvas_wall/:type" element={<GalleryWallListing />} />
          {/* <Route path="sub-category" element={<SubCategory />} /> */}
          <Route path="product" element={<Product />} />
          <Route path="order" element={<Order />} />
          <Route path="order/view_order/:id" element={<ViewOrder />} />
          <Route path="transaction" element={<Transaction />} />
          <Route path="Edge_listing" element={<EdgeListing />} />

          <Route path="content" element={<Content />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="terms-condition" element={<PrivacyPolicy/>} />
          <Route path="bio-video" element={<BioVideo/>} />
          {/* new */}
          <Route path="company_details" element={<CompanyDetails />} />
          <Route path="price_list" element={<PriceList />} />
          <Route path="sales_tax" element={<Salestax />} />
          <Route path="mail_list" element={<MailList />} />
          <Route path="coupon" element={<Coupon />} />
          <Route path="gift_cards" element={<GiftVouchers />} />
          <Route path="banner" element={<Banner />} />
          <Route
            path="personal_shopper_list"
            element={<PersonalShopperList />}
          />
          <Route path="question_list" element={<Topquestion />} />
          <Route path="faq_list" element={<Faq />} />
          <Route path="user_query" element={<ConnectedCustomers />} />
          <Route path="digital_services" element={<DigitalServices />} />
          <Route path="footer_name_list" element={<FooterName />} />
          <Route path="payment_credentails" element={<Paymentcredentails />} />
          <Route path="Image_listing" element={<ImageListing />} />
          <Route path="frames" element={<FramesListing />} />
          <Route path="seo_listing" element={<ManageSEO />} />
          <Route path="cart_mail" element={<CartMail />} />
          <Route path="header_image_listing" element={<HeaderImageListing />} />
          <Route
            path="shipping_information"
            element={<ShippingInformation />}
          />
          <Route path="shipping_charges" element={<Shippingcharges />} />
          <Route path="shipping_pages" element={<Shippingpages />} />

          <Route path="states" element={<StateList />} />
          <Route path="delivery_partner" element={<DeliveryPartner />} />
          <Route path="email_temp" element={<EmailTemplate />} />
          {/*  */}
          <Route path="profile" element={<Profile />} />
          <Route path="change-password" element={<ChangePassword />} />
        </Route>

        <Route path="*" element={<Navigate to="login" />} />
      </Routes>

      <ToastContainer />
    </div>
  );
}

export default App;
